
import { $$, on } from "../../utils/dom";

export const onContentLoaded = (): void => {
    const dialogs = $$('[js-dialog]') as NodeListOf<HTMLDialogElement>;

    dialogs?.forEach(function (dialog) {
        const openButton = dialog.querySelector('button[js-dialog__open]');
        const closeButtons = dialog.querySelectorAll('button[js-dialog__close]');

        openButton?.addEventListener('click', function () {
            dialog.showModal();
        });

        closeButtons?.forEach(function (button) {
            // Find all close buttons and add click event listener
            button.addEventListener('click', function () {
                dialog.close();
            });
        });
    });
};

if (process.env.NODE_ENV !== "development") {
    on(document, "DOMContentLoaded", onContentLoaded);
}
